$(function() {
	$('.callout a.close').click((e) => {
		$(e.currentTarget).parents('.callout').remove();
	});
})



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.common/callouts.js